import { FETCH_ENTITY_HIERARCY, DEVICE,DEVICE_BY_IDS } from "../../constants/apis";
import { replaceMultiple } from "../../utilities/helpers";

export const fetchEntityHeirarcy =
  (nodeType = null, nodeId = 0) =>
  (dispatch, getState, { apiAuth }) => {
    const url = replaceMultiple(FETCH_ENTITY_HIERARCY, {
      "{NODE_TYPE}": nodeId === 0 ? "ROOT" : nodeType,
      "{NODE_ID}": nodeId,
    });
    return apiAuth
      .get(url)
      .then((result) => result)
      .catch((error) => {
        throw error;
      });
  };

export const fetchSingleDevice =
  (id) =>
  (dispatch, getState, { apiAuth }) => {
    const url = `${DEVICE}/${id}`;
    return apiAuth
      .get(url)
      .then((result) => result)
      .catch((error) => {
        throw error;
      });
  };

export const fetchDeviceByIds =
  (ids) =>
  (dispatch, getState, { apiAuth }) =>
    apiAuth
      .post(DEVICE_BY_IDS, { ids })
      .then((result) => result)
      .catch((error) => {
        throw error;
      });
